import clsx from "clsx";
import type { ReactNode } from "react";
import { Link } from "react-router-dom";

import { LoadingSkeleton } from "@/components/common";

type AsideMenuTalentRoute = {
  name: string;
  path: string;
};

type AsideMenuTalentLayoutProps = {
  actions: ReactNode;
  basePathname: string;
  card: ReactNode;
  header?: ReactNode;
  isLoading?: boolean;
  pathname: string;
  routes?: AsideMenuTalentRoute[];
};

export const AsideMenuTalentLayout = ({
  actions,
  basePathname,
  card,
  header,
  isLoading = false,
  pathname,
  routes,
}: AsideMenuTalentLayoutProps) => (
  <aside className="w-full flex-col md:flex md:w-72">
    {header && <div className="bg-white py-2 px-4">{header}</div>}

    <div className="relative h-[19rem] w-full">
      {isLoading ? <LoadingSkeleton kind="card" className="h-[19rem] w-full rounded-none" /> : card}
    </div>
    <div className="flex flex-col gap-1 border border-input-border bg-white p-4">
      {routes?.map((route) => {
        const isActiveRoute = pathname === `${basePathname}${route.path}`;

        return (
          <Link to={`${basePathname}${route.path}`} key={route.path} className="block w-full">
            <button
              className={clsx("w-full rounded-md hover:bg-primary-hover", {
                "bg-primary-hover": isActiveRoute,
              })}
            >
              <span
                className={clsx("flex flex-1 p-2 text-start text-sm font-light hover:text-primary", {
                  "!font-bold text-primary": isActiveRoute,
                })}
              >
                {route.name}
              </span>
            </button>
          </Link>
        );
      })}
    </div>
    <div className="flex flex-col gap-4 pt-2">{actions}</div>
  </aside>
);
